import React, { useState } from 'react';
import styled from 'styled-components';
import { FaUserCircle } from 'react-icons/fa';

const UserIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="80"
    height="80"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="7" r="4" />
    <path d="M12 17s-8-4.5-8-8a8 8 0 0 1 16 0c0 3.5-8 8-8 8z" />
  </svg>
);

const FormContainer = styled.div`
  max-width: 400px;
  margin: 0 auto;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
  font-family: 'Montserrat', sans-serif;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 325px;
  padding:16px;
  border-radius:8px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  margin-top:15vh;
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  font-weight: 800;
  font-size: 14px;
  color: #07082c;
`;

const Input = styled.input`
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
`;

const SelectContainer = styled.div`
  position: relative;
`;

const Select = styled.select`
  appearance: none;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  background-color: white;
  cursor: pointer;
  width: 100%;
`;

const DropdownIcon = styled.div`
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
`;

const ErrorMessage = styled.div`
  color: red;
`;

const AvatarInputContainer = styled.label`
  position: relative;
  width: 3vw; /* Tamaño del avatar en relación con el ancho de la pantalla */
  height: 3vw; /* Tamaño del avatar en relación con el ancho de la pantalla */
  max-width: 100px; /* Máximo tamaño del avatar */
  max-height: 100px; /* Máximo tamaño del avatar */
  border-radius: 50%;
  border: 2px dashed #ccc;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;

const Avatar = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const NoPhotoIcon = styled(FaUserCircle)`
  width: 3vw; /* Tamaño del icono en relación con el ancho de la pantalla */
  height: 3vw; /* Tamaño del icono en relación con el ancho de la pantalla */
//   max-width: 35px; /* Máximo tamaño del icono */
//   max-height: 35px; /* Máximo tamaño del icono */
  color: #ccc;
`;

const CreateUserForm = () => {
  const [formData, setFormData] = useState({
    photo: null,
    name: '',
    lastname: '',
    phone: '',
    email: '',
    password: '',
    type: 'Admin',
  });

  const [errors, setErrors] = useState({
    photo: '',
    name: '',
    lastname: '',
    phone: '',
    email: '',
    password: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    setFormData({
      ...formData,
      photo: file,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let formIsValid = true;
    const newErrors = {};

    if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Por favor ingresa un correo electrónico válido';
      formIsValid = false;
    }

    if (!/^\d{10}$/.test(formData.phone)) {
      newErrors.phone = 'Por favor ingresa un número de teléfono válido';
      formIsValid = false;
    }

    setErrors(newErrors);

    if (formIsValid) {
      try {
        if (formData.photo) {
          const photoUrl = await uploadPhotoToS3(formData.photo);
          setFormData({
            ...formData,
            photo: photoUrl,
          });
        }

        console.log('Datos del usuario:', formData);
      } catch (error) {
        console.error('Error al cargar la foto al S3:', error);
      }
    } else {
      console.log('El formulario no es válido. Por favor, corrija los errores.');
    }
  };

  const uploadPhotoToS3 = async (photoData) => {
    return 'https://example.com/photo.jpg'; // URL simulada
  };

  return (
    <ContainerBox >
      <Form onSubmit={handleSubmit}>
        <FormGroup>
          <Label htmlFor="photo">Foto de perfil {'(opcional)'}</Label>
          <AvatarInputContainer>
            {formData.photo ? (
              <Avatar src={URL.createObjectURL(formData.photo)} alt="Avatar" />
            ) : (
              <NoPhotoIcon>{UserIcon}</NoPhotoIcon>
            )}
            <input
              type="file"
              id="photo"
              name="photo"
              accept="image/*"
              onChange={handlePhotoChange}
              style={{ display: 'none' }}
            />
          </AvatarInputContainer>
          {errors.photo && <ErrorMessage>{errors.photo}</ErrorMessage>}
        </FormGroup>

        <FormGroup>
          <Label htmlFor="name">Nombre *</Label>
          <Input type="text" id="name" name="name" value={formData.name} onChange={handleChange} />
          {errors.name && <ErrorMessage>{errors.name}</ErrorMessage>}
        </FormGroup>

        <FormGroup>
          <Label htmlFor="lastname">Apellido *</Label>
          <Input
            type="text"
            id="lastname"
            name="lastname"
            value={formData.lastname}
            onChange={handleChange}
          />
          {errors.lastname && <ErrorMessage>{errors.lastname}</ErrorMessage>}
        </FormGroup>

        <FormGroup>
          <Label htmlFor="phone">Teléfono *</Label>
          <Input
            type="text"
            id="phone"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
          />
          {errors.phone && <ErrorMessage>{errors.phone}</ErrorMessage>}
        </FormGroup>

        <FormGroup>
          <Label htmlFor="type">Tipo de usuario</Label>
          <SelectContainer>
            <Select id="type" name="type" value={formData.type} onChange={handleChange}>
              <option value="Admin">Admin</option>
              <option value="Supervisor">Supervisor</option>
              <option value="Asesor">Asesor</option>
              <option value="Promotor">Promotor</option>
              <option value="Cliente">Cliente</option>
            </Select>
            <DropdownIcon>▼</DropdownIcon>
          </SelectContainer>
        </FormGroup>

        <FormGroup>
          <Label htmlFor="email">Correo electrónico *</Label>
          <Input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
          />
          {errors.email && <ErrorMessage>{errors.email}</ErrorMessage>}
        </FormGroup>

        <FormGroup>
          <Label htmlFor="password">Contraseña *</Label>
          <Input
            type="password"
            id="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
          />
          {errors.password && <ErrorMessage>{errors.password}</ErrorMessage>}
        </FormGroup>

        <button type="submit">Crear Usuario</button>
      </Form>
      </ContainerBox>
  );
};

export default CreateUserForm;
const ContainerBox = styled.div`
width: -webkit-fill-available;
height: auto;
min-height: 100vh;
max-height: 100vh;
overflow-y: auto;
max-width: calc(100vw - 300px);
gap: 16px;
display: flex;
flex-direction: column;
align-items: center;
margin: 0%;
padding: 0% 2% 0% 2%;
background: #ffffff;
  box-shadow: 0px 1.5px 2px 0px rgba(16, 24, 40, 0.10);
  border: 1px solid var(--Neutral-Gray-Gray-100, #E0E2E7);
`;